var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.582 0 0 3.582 0 8c0 3.54 2.298 6.533 5.47 7.59.4.073 .546-.174 .546-.386 0-.19-.007-.822-.01-1.49-2.002.366-2.958-.49-3.136-.944-.106-.266-.56-1.065-.952-1.28-.324-.174-.784-.604-.007-.616 .728-.012 1.25 .67 1.423 .943 .838 1.39 2.18 1.005 2.71 .765 .083-.606 .324-1.005 .587-1.235-2.05 -.232-4.2 -1.017-4.2 -4.52 0-1.002 .358-1.82 .943-2.46-.09 -.23-.408-1.165 .09-2.428 0 0 .77-.246 2.52 .943 .73 -.204 1.51 -.306 2.28 -.31 .77 .004 1.55 .106 2.28 .31 1.75-1.19 2.52-.943 2.52 -.943 .5 1.263 .18 2.198 .09 2.428 .58 .64 .94 1.457 .94 2.46 0 3.51-2.16 4.284-4.22 4.52 .33 .283 .62 .84 .62 1.7 0 1.23 -.01 2.22 -.01 2.52 0 .21 .14 .46 .55 .385C13.704 14.533 16 11.54 16 8c0-4.418-3.582-8-8-8z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.567eb654658a092b8f492189c58facd9.svg";
export { ForwardRef as ReactComponent };